import { render, staticRenderFns } from "./SetElement.vue?vue&type=template&id=bc04d4b0&lang=pug&"
import script from "./SetElement.vue?vue&type=script&lang=js&"
export * from "./SetElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports